// extracted by mini-css-extract-plugin
export var text = "_ad-0";